/**
 * @prettier
 */
const uuidGenerator = () => "3fa85f64-5717-4562-b3fc-2c963f66afa6"

export default uuidGenerator
